var _g, _path, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSToothImplant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ph-currency-gbp"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "iconS-implant",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3,21.968l0,-3.696c0,-1.297 1.053,-2.35 2.35,-2.35l4.7,-0c1.297,-0 2.35,1.053 2.35,2.35l0,3.696l-9.4,-0Zm-2.3,-0c-0.006,0.548 -1.068,0.677 -1.576,0.471c-0.51,-0.207 -1.292,-0.905 -1.486,-1.712c-0.307,-1.276 -0.925,-2.207 -2.088,-3.814c-1.339,-1.851 -1.936,-4.295 -1.316,-6.896c0.673,-2.827 2.885,-5.124 5.631,-5.858c1.439,-0.375 2.824,-0.032 4.094,0.648l6.152,4.038c0.474,0.312 1.079,0.133 1.354,-0.305c0.29,-0.461 0.16,-1.077 -0.299,-1.382l-1.729,-1.133c0.214,-0.109 0.444,-0.195 0.643,-0.344c1.599,-1.202 3.481,-2.046 5.455,-1.523c2.747,0.734 4.959,3.03 5.631,5.858c0.618,2.605 0.025,5.055 -1.317,6.897c-1.159,1.6 -1.861,2.731 -2.062,3.814c-0.152,0.818 -0.981,1.593 -1.496,1.712c-0.515,0.119 -1.565,-0.373 -1.595,-1c-0.033,-0.686 0.004,-3.167 0.004,-3.167c-0,-2.567 -2.084,-4.65 -4.65,-4.65l-4.7,-0c-2.566,-0 -4.65,2.083 -4.65,4.65c0,-0 0.012,2.572 0,3.696Zm12.5,8.066c0,0.635 -0.515,1.15 -1.15,1.15l-8.7,0c-0.635,0 -1.15,-0.515 -1.15,-1.15c0,-0.634 0.515,-1.15 1.15,-1.15l8.7,0c0.635,0 1.15,0.516 1.15,1.15Zm1.5,-4.623c0,0.635 -0.515,1.15 -1.15,1.15l-11.7,0c-0.635,0 -1.15,-0.515 -1.15,-1.15c0,-0.635 0.515,-1.15 1.15,-1.15l11.7,0c0.635,0 1.15,0.515 1.15,1.15Zm-3.5,9.224c0,0.635 -0.515,1.15 -1.15,1.15l-4.7,0c-0.635,0 -1.15,-0.515 -1.15,-1.15c0,-0.634 0.515,-1.15 1.15,-1.15l4.7,0c0.635,0 1.15,0.516 1.15,1.15Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "clock"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "bars-progress"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "timeline"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "search"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "ph-desktop"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "ph-note-pencil"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "ph-pen-nib"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "at"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "sliders-up"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "file"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "file-earmark"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "file1",
    serifid: "file"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "boxes-stacked"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "chat-left-text"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "arrow-up"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "at1",
    serifid: "at"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "rocket"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "pen-to-square"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "pen"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "timer"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "rectangle-vertical-history"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "list-timeline"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "toggle2-on"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right-long"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "sliders2-vertical"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "crown"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "skype"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "clock-history"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "ph-pencil-simple"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass1",
    serifid: "magnifying-glass"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "cloud-arrow-up"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "box-archive"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "archive"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "clipboard-list"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "speedometer2"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "link-45deg"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "clipboard2-x"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "clipboard2-plus"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "clipboard-plus"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "toggle2-on1",
    serifid: "toggle2-on"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "toggle2-off"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "pin-map"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "ph-link"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "sliders-up1",
    serifid: "sliders-up"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "check-double"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "sliders2-vertical1",
    serifid: "sliders2-vertical"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "three-dots-vertical"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right-long1",
    serifid: "arrow-right-long"
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "at2",
    serifid: "at"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "ph-lightning-fill"
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "gem"
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "ph-timer-fill"
  })), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "patch-check-fill"
  })), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "lightning-fill"
  })), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "gem1",
    serifid: "gem"
  })), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "clock-fill"
  })), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "ph-arrows-out-line-vertical-bold"
  })), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "ph-check-fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSToothImplant);
export default __webpack_public_path__ + "static/media/iconS-tooth-implant.45c1b15eb6d50414592dd525fcd412de.svg";
export { ForwardRef as ReactComponent };